import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=c06a6c9e&"
import script from "./login-password.vue?vue&type=script&lang=ts&"
export * from "./login-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports